import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedLayout from "@/components/ProtectedLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Checker from "@/pages/Checker";
import Shop from "@/pages/Shop";
import Announcements from "@/pages/Announcements";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import History from "@/pages/History";
import { Help, ApiDocs, Community } from "@/pages/Resources";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/panel" element={<Dashboard />} />
            <Route path="/checker" element={<Navigate to="/checker/discord" replace />} />
            <Route path="/checker/:platform" element={<Checker />} />
            <Route path="/magaza" element={<Shop />} />
            <Route path="/duyurular" element={<Announcements />} />
            <Route path="/profil" element={<Profile />} />
            <Route path="/gecmis" element={<History />} />
            <Route path="/yardim" element={<Help />} />
            <Route path="/api-docs" element={<ApiDocs />} />
            <Route path="/topluluk" element={<Community />} />
          </Route>
          <Route element={<ProtectedLayout adminOnly />}>
            <Route path="/admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}
